import { Flex, Form } from "@/atoms"
import { RadioGroup } from "../RadioGroup"
import { SectionFormTemplate } from "../SectionFormTemplate"

import type { RadioGroupSectionFormTemplateProps } from "."

export const RadioGroupSectionFormTemplate = (
  props: RadioGroupSectionFormTemplateProps
) => {
  const { sectionId, title, Icon, fieldName, items, form, layout, disabled } =
    props
  const fieldValue = Form.useWatch(fieldName, form)

  return (
    <SectionFormTemplate id={sectionId} title={title} Icon={Icon}>
      <Flex vertical gap={10}>
        {props.info}
        <Form.Item required={false} name={fieldName} layout={layout}>
          <RadioGroup
            data-testid="radio_group_section_form"
            disabled={disabled}
          >
            {items.map((item, index) => {
              const key = index

              if (!item.children) return <RadioGroup.Card key={key} {...item} />

              const { children, ...rest } = item
              const selected = fieldValue === item.value

              return (
                <RadioGroup.Card key={key} selected={selected} {...rest}>
                  <Flex
                    vertical
                    gap={8}
                    className="wrapper-list-radio-group-section-ks"
                  >
                    {children}
                  </Flex>
                </RadioGroup.Card>
              )
            })}
          </RadioGroup>
        </Form.Item>
      </Flex>
    </SectionFormTemplate>
  )
}
